// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function groupName(t) {
  switch (t.TAG) {
    case "Questions" :
        return "Questions";
    case "ThankYous" :
        return "ThankYous";
    case "DataFields" :
        return "DataFields";
    case "RedirectionUrls" :
        return "RedirectionUrls";
    case "TicketCategories" :
        return "TicketCategories";
    
  }
}

function optionLabelElement(prefix, text) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("p", {
                            children: prefix,
                            className: "text-xs text-white"
                          }),
                      className: "rounded-full bg-pigmentblue text-center items-center p-1"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: text,
                            className: "truncate"
                          }),
                      className: "flex items-center"
                    })
              ],
              className: "flex gap-1"
            });
}

function optionLabel(option) {
  var element = option[1];
  return JsxRuntime.jsx("div", {
              children: element._0
            });
}

exports.groupName = groupName;
exports.optionLabel = optionLabel;
exports.optionLabelElement = optionLabelElement;
/* react/jsx-runtime Not a pure module */
